import React, { ReactNode } from 'react';

import { useTheme } from '@reckon-web/theme';
import { Flex } from '@reckon-web/flex';
import { Text } from '@reckon-web/text';
import { hexToRgb } from '@reckon-web/utils';

export type SingleSignOnButtonProps = {
  label: string;
  onClick: () => void;
  icon: ReactNode;
};

export const SingleSignOnButton = ({
  label,
  icon,
  onClick,
}: SingleSignOnButtonProps) => {
  const { palette } = useTheme();
  return (
    <Flex
      as="button"
      onClick={onClick}
      // styles
      alignItems="center"
      background="base"
      border="muted"
      borderRadius="medium"
      gap="small"
      justifyContent="center"
      padding="medium"
      width="100%"
      css={{
        '&:hover': {
          background: hexToRgb(palette.button.passive.background, 0.2),
        },
        '&:active': {
          background: hexToRgb(palette.button.passive.background, 0.3),
        },
      }}
    >
      {icon}
      <Text weight="medium">{label}</Text>
    </Flex>
  );
};
